import { apiGet } from "../../utils"

export function getVideoLinksAPI(data) {
    return apiGet("/api/getVideoLinks", data)
}

export function getNewsAPI(data) {
    return apiGet("/api/getNews", data)
}